import axios, { AxiosInstance } from "axios";
import authData from "../services/authData";

export const getToken = () => {
  const token = authData?.get() ?? "";
  return "Bearer " + token;
};
